"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resources_1 = require("../resources");
var _1 = require(".");
exports.getFactorDescriptions = function (id, factors, custom) {
  return Object.keys(factors).length > 0 ? Object.keys(factors).map(function (factor) {
    return custom && custom.factors && custom.factors[factor] ? custom.factors[factor] : resources_1.factorDescriptionsByScore[id][factor];
  }) : [resources_1.noFactors];
};
exports.getScoreDescriptions = function (id, value, custom) {
  var customDescriptions = custom ? custom.score : {};
  var customDescId = _1.findIdByScore(value, customDescriptions);
  var defaultDescId = _1.findOrDefaultByScore(value, resources_1.scoreDescriptions[id]);
  return customDescId ? customDescriptions[customDescId] : resources_1.scoreDescriptions[id][defaultDescId];
};
exports.getDescriptions = function (details, customizations) {
  var factors = details.factors,
    id = details.score.id,
    value = details.value;
  var customDescriptions = customizations && customizations.descriptions && customizations.descriptions[id];
  return {
    factors: exports.getFactorDescriptions(id, factors, customDescriptions),
    score: exports.getScoreDescriptions(id, value, customDescriptions)
  };
};